import(/* webpackMode: "eager" */ "/home/runner/work/minimals-showcase/minimals-showcase/src/app/[domain]/[lng]/loading.tsx");
